/**
 * RegulatoryGovernancePage - Regulatory governance dashboard
 *
 * Surfaces the RegulatoryGovernanceDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides visibility into regulatory compliance status, audit trails, and governance metrics.
 *
 * Route: /admin/regulatory-governance
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconGavel } from '@tabler/icons-react';

import { RegulatoryGovernanceDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function RegulatoryGovernancePage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="indigo">
            <IconGavel size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Regulatory Governance</Title>
            <Text size="sm" c="dimmed">
              Regulatory compliance status, audit trails, and governance metrics
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <RegulatoryGovernanceDashboard />
    </Container>
  );
}

export default RegulatoryGovernancePage;
